import { c as _c } from "react/compiler-runtime";
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import ProgressBarFilled from 'shared/components/progress-bar-filled';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { withErrorBoundary } from 'shared/hocs/with-error-boundary';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { ContactId } from '../../types/contact-interface';
import { useContactCourses } from '../hooks/use-contact-courses';
import { ContactCoursesInterface } from '../types/contact-courses-interface';
interface ContactCoursesProps {
  contactId: ContactId;
}
const ContactCourses = t0 => {
  const $ = _c(34);
  const {
    contactId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    limit,
    pagination,
    setLimit,
    setPagination
  } = usePagination(true);
  let t1;
  if ($[0] !== contactId || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      contactId,
      limit,
      pagination
    };
    $[0] = contactId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    contactCourses
  } = useContactCourses(t1);
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.contact_page.courses.headers.name");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      key: "course" as keyof ContactCoursesInterface,
      widthPercent: 50,
      header: t2,
      onRender: _temp
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.contact_page.courses.headers.progress");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      key: "progress",
      widthPercent: 50,
      header: t4,
      onRender: _temp2
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = [t3, t5];
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const columns = t6;
  let t7;
  if ($[15] !== t) {
    t7 = t("dashboard.courses.title_plural");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <h2 className="h-[42px] text-[17px] font-bold">{t7}</h2>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== pagination || $[20] !== setPagination) {
    t9 = {
      pagination,
      setPagination
    };
    $[19] = pagination;
    $[20] = setPagination;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== limit || $[23] !== setLimit) {
    t10 = {
      limit,
      setLimit
    };
    $[22] = limit;
    $[23] = setLimit;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== columns || $[26] !== contactCourses || $[27] !== t10 || $[28] !== t9) {
    t11 = <Table columns={columns} data={contactCourses} paginator={t9} limiter={t10} isSortable={false} nestedId="course" />;
    $[25] = columns;
    $[26] = contactCourses;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== contactCourses || $[31] !== t11 || $[32] !== t8) {
    t12 = <ListingLayout counter={false} data={contactCourses} title={t8} type="compact">{t11}</ListingLayout>;
    $[30] = contactCourses;
    $[31] = t11;
    $[32] = t8;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
export default withErrorBoundary(ContactCourses);
function _temp(t0) {
  const {
    course
  } = t0;
  return <LinkWithoutPrefetch className="primary-link w-full whitespace-normal" href={`/courses/${course.id}/curriculum`}>{course.name}</LinkWithoutPrefetch>;
}
function _temp2(course_0) {
  return <ProgressBarFilled progress={course_0.progress} />;
}